// extracted by mini-css-extract-plugin
export default {"link":"BlogCategory-module--link--55092"};